import { render, staticRenderFns } from "./ProductRow.vue?vue&type=template&id=63aa739c&scoped=true"
import script from "./ProductRow.vue?vue&type=script&lang=ts"
export * from "./ProductRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aa739c",
  null
  
)

export default component.exports